export default __webpack_public_path__ + "static/if-hero-badge-315313fad750e7cfcf596a690b6072a8.png";